const ArrowRightIcon = ({ ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 7.99984L2 7.99984M9.33333 3.33317L14 7.99984L9.33333 3.33317ZM14 7.99984L9.33333 12.6665L14 7.99984Z"
        stroke="#353D48"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRightIcon;
